// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"55":"error-msg","63":"NotFoundPage"}[chunkId] || chunkId) + "." + {"55":"d8d094ae","63":"635ab545","453":"b4e751e2","639":"868fc100"}[chunkId] + ".chunk.js";
};